module.exports = __webpack_public_path__ + "static/media/image5.85ce7eb4.jpg";